module.exports = __webpack_public_path__ + "static/media/menuWorld.8c435e0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuWorld.svg
// module id = 490
// module chunks = 0